module.exports = __webpack_public_path__ + "static/media/menuicon.ed0ce356.svg";